// @flow
const customApiUrl = process.env.CUSTOM_API_URL;

if (customApiUrl) {
  console.log('Setting up custom api url:', customApiUrl);
}

const env = {
  version: process.env.VERSION,
  env: 'local',
  baseUrl: {
    US: 'http://www.giwiro.com',
    PE: 'http://www.giwiro.com.pe',
    CO: 'http://www.giwiro.com.co',
  },
  apiUrl: customApiUrl || '/v3',
  ioBaseUrl: 'ws://api.giwiro.com',
  // facebook: '430365700492582',
  facebook: '225598827837226',
  googleMaps: 'AIzaSyDYJ6f8DTqJYOIUcxJV3cO_Y2A4B3KVAEE',
  paypal: 'Aa7fN-vot0j7E9cNa2hya7nfn7IWoAhqO9c34q5lApO2yn35XRrFS-Vtgkhe4cTJTZ6P5_CB03mH4Q1W',
  sentry: 'https://3eb17f6fad294380b80011754d75fed1@sentry.io/1273849',
  // amazonPaySellerId: 'AUJIS8EFC5PK3',
  // amazonPayClientId: 'amzn1.application-oa2-client.03a2f5e47bf44f8ebb47e9c8af5778a3',
  // amazonPayJsLib: 'https://static-na.payments-amazon.com/OffAmazonPayments/us/sandbox/js/Widgets.js',
  authorizeJsLib: 'https://jstest.authorize.net/v3/AcceptUI.js',
  authorizeClientKey: '72v7a3sbY4g4yqEkDK3ALC6R5W2ET5a47jgFKDEh8tsA39Vbpw6LUXWTqSxMTepV',
  authorizeLoginId: '3LD2wem5nqHL',
  googleAnalytics: 'G-JJYRJMRN07',
  // googleAnalytics: 'UA-125173542-1',
  googleTagManager: 'GTM-TKZ3FFW',
  // googleOptimize: 'GTM-TVR3PMM',
  // culqi: 'pk_test_41e2bf707c3aa43c',
  culqi: 'pk_test_qpbCb2QGJb5x7WNy', // Tmp culqi test keys
  blueSnapLib: 'https://sandbox.bluesnap.com/source/web-sdk/bluesnap.js',
  blueSnapBackupLib: 'http://www.giwiro.com/js/vendor/bluesnap.js',
  segment: '1u9luLDRyMuiqqRH90OiDxnhV1Waaize',
  notifia: 'JQgZcmS51DVy',
  smartsupp: 'd6bf3346121553f34ed9bb993c51c20e53a18a3c',
  share_url: 'https://share.staging.qempo.com',
  paymeJsLib: 'https://integracion.alignetsac.com/VPOS2/js/modalcomercio.js',
  niubizCssLib: 'https://pocpaymentserve.s3.amazonaws.com/payform.min.css',
  niubizJsLib: 'https://pocpaymentserve.s3.amazonaws.com/payform.min.js',
  niubizFormJsLib: 'https://static-content-qas.vnforapps.com/v2/js/checkout.js?qa=true',
  // PEN
  // niubizMerchanId: '522591303',
  // USD
  niubizMerchanId: '750000004',
  topBannerUrl: 'https://staging.qempo.com.pe/0660528664/top-banner',
  searchTopBannerUrl: 'https://staging.qempo.com.pe/search/top-banner',
  // qempo.io-pages
  // qempoIoPagesUrl: 'https://pages.dev.qempo.io',
  qempoIoPagesUrl: 'https://pages.dev.qempo.io',
};

if (process.env.WEBAPP_ENV === 'local') {
  // console.log('WEBAPP_ENV=local');
} else if (process.env.WEBAPP_ENV === 'development') {
  // console.log('WEBAPP_ENV=development');
  env.env = 'development';
  env.baseUrl = {
    US: 'http://dev.qempo.com',
    PE: 'http://dev.qempo.com.pe',
    CO: 'http://dev.qempo.com.co',
  };
  env.apiUrl = customApiUrl || '/v3';
  env.ioBaseUrl = 'wss://api.dev.qempo.com';

  // env.googleAnalytics = 'UA-125173542-2';
  env.googleAnalytics = 'G-JJYRJMRN07';
  env.googleTagManager = 'GTM-5NKVZD6';
  // env.googleOptimize = 'GTM-5QQPJX6';
  env.segment = '1u9luLDRyMuiqqRH90OiDxnhV1Waaize';
  env.share_url = 'https://share.staging.qempo.com';
  env.topBannerUrl = 'https://staging.qempo.com.pe/0660528664/top-banner';
  env.searchTopBannerUrl = 'https://staging.qempo.com.pe/search/top-banner';
} else if (process.env.WEBAPP_ENV === 'staging') {
  // console.log('WEBAPP_ENV=staging');
  env.env = 'staging';
  env.baseUrl = {
    US: 'http://staging.qempo.com',
    PE: 'http://staging.qempo.com.pe',
    CO: 'http://staging.qempo.com.co',
  };
  env.apiUrl = customApiUrl || '/v3';
  env.ioBaseUrl = 'wss://api.staging.qempo.com';
  // env.facebook = '485875588484303';
  env.facebook = '225598827837226';

  env.blueSnapBackupLib = 'https://staging.qempo.com/assets/js/vendor/bluesnap.js';
  // env.googleAnalytics = 'UA-125173542-2';
  env.googleAnalytics = 'G-JJYRJMRN07';
  env.googleTagManager = 'GTM-5NKVZD6';
  // env.googleOptimize = 'GTM-5QQPJX6';
  env.segment = '1u9luLDRyMuiqqRH90OiDxnhV1Waaize';

  env.notifia = 'JQgZcmS51DVy';
  env.share_url = 'https://share.staging.qempo.com';
  env.topBannerUrl = 'https://staging.qempo.com.pe/0660528664/top-banner';
  env.searchTopBannerUrl = 'https://staging.qempo.com.pe/search/top-banner';
} else if (process.env.WEBAPP_ENV === 'production') {
  // console.log('WEBAPP_ENV=production');
  env.env = 'production';
  env.baseUrl = {
    US: 'https://www.qempo.com',
    PE: 'https://www.qempo.com.pe',
    CO: 'https://www.qempo.com.co',
  };
  env.apiUrl = customApiUrl || '/v3';
  env.ioBaseUrl = 'wss://api.qempo.com';
  env.facebook = '225598827837226';
  env.googleMaps = 'AIzaSyDYJ6f8DTqJYOIUcxJV3cO_Y2A4B3KVAEE';
  env.paypal = 'AYG9IZsTnBPaibtYefbdiE4q8E9o-1IhOlYCHEch3-ulnL8dA3QRImVIkcFgdt9KLv5OmtRN9Gy7n4Fq';
  env.sentry = 'https://3eb17f6fad294380b80011754d75fed1@sentry.io/1273849';
  // env.amazonPaySellerId = 'AUJIS8EFC5PK3';
  // env.amazonPayClientId = 'amzn1.application-oa2-client.03a2f5e47bf44f8ebb47e9c8af5778a3';
  // env.amazonPayJsLib = 'https://static-na.payments-amazon.com/OffAmazonPayments/us/js/Widgets.js';
  env.authorizeJsLib = 'https://js.authorize.net/v3/AcceptUI.js';
  env.authorizeClientKey = '7AA2G5u2R393q7HvHCR73hteBEAaga3Z5BQ7C4WZf2Uf2tuu4T7xp3UaSrmzuxR9';
  env.authorizeLoginId = '8CH2XEb38b4';
  // env.googleAnalytics = 'UA-125173542-3';
  env.googleAnalytics = 'G-9L9JK91JWY';
  env.googleTagManager = 'GTM-NXR7LKC';
  // env.googleOptimize = 'GTM-TZRPVG9';
  // env.culqi = 'pk_live_ITuuwM030OKmN8aK';
  env.culqi = 'pk_live_18bd6fdf884e8ac1';
  env.blueSnapLib = 'https://ws.bluesnap.com/source/web-sdk/bluesnap.js';
  env.blueSnapBackupLib = 'https://www.qempo.com/assets/js/vendor/bluesnap.js';
  env.segment = '5Q9daAceiaVbznH55z5GBpQTSCmOq1gh';
  env.share_url = 'https://share.qempo.com';
  env.paymeJsLib = 'https://vpayment.verifika.com/VPOS2/js/modalcomercio.js';
  env.niubizCssLib = 'https://static-content.vnforapps.com/elements/v1/payform.min.css';
  env.niubizJsLib = 'https://static-content.vnforapps.com/elements/v1/payform.min.js';
  env.niubizFormJsLib = 'https://static-content.vnforapps.com/v2/js/checkout.js';
  env.niubizMerchanId = '650178162';
  env.topBannerUrl = 'https://qempo.com.pe/0660528664/top-banner';
  env.searchTopBannerUrl = 'https://qempo.com.pe/search/top-banner';
  env.qempoIoPagesUrl = 'https://pages.qempo.io';
}

// export default env;
module.exports = env;



// WEBPACK FOOTER //
// ./src/environment/index.js